export default "__VITE_ASSET__b5fc7ead__"